const signinMethods = {
    1: "موبایل",
    2: "ایمیل",
    3: "رمز عبور"
}

export default signinMethods;